// src/mocks/handlers/account/payoutAccountsHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import payoutAccountsData from '@/mocks/data/payoutAccounts.json';
import {
  IRequestPayoutAccounts,
  IPayoutAccountsResponse,
  IPayoutAccounts,
} from '@/domains/account/payout_accounts/payoutAccounts.types';

export const payoutAccountsHandler = rest.get<
  IPayoutAccountsResponse,
  IRequestPayoutAccounts
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_PAYOUT_ACCOUNTS}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }
    const payoutAccounts = payoutAccountsData.find(
      (entry) => entry.customer === customer_uuid,
    );

    const accounts: IPayoutAccounts[] = payoutAccounts
      ? payoutAccounts.results
      : [];

    return res(ctx.status(200), ctx.json({ results: accounts }));
  },
);
